/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { ListQuery } from './listQuery.schema';

export const SearchTransmittalRecords = zod.object({
  "payload": zod.lazy(() => ListQuery).optional()
});

export type SearchTransmittalRecords = zod.input<typeof SearchTransmittalRecords>;
export type SearchTransmittalRecordsOutput = zod.output<typeof SearchTransmittalRecords>;
